// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navigation-module--navigation--1ZdF3","header":"navigation-module--header--3ulMs","navigationItem":"navigation-module--navigationItem--3T1mO"};